<template>
	<div
	v-touch:tap="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	style="user-select: none;"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link">

		<template v-if="data">

			<button class="btn btn-danger float-right" v-if="showDeleteBtn" v-touch:tap.stop="deleteItem">{{$t('delete')}}</button>

			<p>
				<template v-if="data.code">
				{{data.code}}:
				</template>
				{{ data.name }}
			</p>

		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
export default {
	props: ['data', 'swipedLeftItem', ],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		deleteItem() {
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/test/delete`, {
				data: {
					id: this.data.id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.data);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {

			// prevent tap for right clicks
			if(e.button && e.button == 2) {
				return false;
			}

			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.data);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.data);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.data);
		},
	},
	computed: {
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.id == this.data.id)
		}
	}
};
</script>
